import React from 'react';
import PropTypes from 'prop-types';
import {
  Collapse, Fade, Grow, Slide, Zoom,
} from '@mui/material';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const VARIANTS = {
  collapse: Collapse,
  fade: Fade,
  grow: Grow,
  slide: Slide,
  zoom: Zoom,
};

const Transition = ({ children, variant, ...rest }) => {
  const Component = VARIANTS[variant];

  return (
    <Component {...rest}>
      <Box>{children}</Box>
    </Component>
  );
};

Transition.defaultProps = {
  in: true,
  timeout: 300,
  variant: 'fade',
};

Transition.propTypes = {
  in: PropTypes.bool,
  timeout: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      enter: PropTypes.number,
      exit: PropTypes.number,
    }),
  ]),
  variant: PropTypes.oneOf(Object.keys(VARIANTS)),
};

export default Transition;
